import { ReactNode } from "react";
import { Navigate } from "src/router";
import { useAdStudioDemoFlagWhenReady } from "./use-is-ad-studio-demo-enabled";

type Props = {
  /** Where flag-off users land. */
  redirect: string;
  children: ReactNode;
};

/**
 * `FeatureFlagRoute` for the demo flag, minus the LaunchDarkly initialization
 * race.
 *
 * `FeatureFlagRoute` treats a not-yet-loaded flag as off and redirects
 * immediately. That redirect unmounts the component that would have
 * re-evaluated the flag once the client resolved, so a flag-on user
 * deep-linking to a demo route is sent to the production route for the rest of
 * the session. Holding the frame until the flag resolves costs one blank paint
 * and gets the right answer.
 */
export const AdStudioDemoRoute = ({ redirect, children }: Props) => {
  const isEnabled = useAdStudioDemoFlagWhenReady();

  if (isEnabled === undefined) return null;

  if (!isEnabled) return <Navigate to={redirect} replace />;

  return <>{children}</>;
};
